<div class="surface-card border-round-xl border-1 border-200 p-4">
  <h3 class="text-lg font-medium text-900 mt-0 mb-1">Safety Flags</h3>
  <p class="text-600 text-sm mt-0 mb-3">
    Environment and communications kill switches for this tenant.
  </p>

  <div *ngIf="loading" class="flex flex-column gap-2">
    <p-skeleton height="2rem" styleClass="border-round w-6 mb-2"></p-skeleton>
    <p-skeleton height="4rem" styleClass="border-round"></p-skeleton>
  </div>

  <div *ngIf="!loading" class="flex flex-column gap-4">
    <div class="flex align-items-center justify-content-between gap-3">
      <div>
        <label class="block font-medium text-900 mb-1">Payment Sandbox Mode</label>
        <small class="text-500">
          On: charges route to the gateway's sandbox/test environment, no real money moves.
          Off: this tenant charges real cards/accounts. Double-check before disabling on a live tenant.
        </small>
      </div>
      <p-inputSwitch [(ngModel)]="paymentSandbox"></p-inputSwitch>
    </div>

    <div class="flex align-items-center justify-content-between gap-3">
      <div>
        <label class="block font-medium text-900 mb-1">Disable Communications</label>
        <small class="text-500">
          When on, every outbound SMS/email for this tenant is blocked (billing, support, surveys,
          referrals - not just billing reminders). For dev/test/demo tenants so real customers are
          never contacted.
        </small>
      </div>
      <p-inputSwitch [(ngModel)]="communicationsDisabled"></p-inputSwitch>
    </div>

    <div class="flex align-items-center justify-content-between gap-3">
      <div>
        <label class="block font-medium text-900 mb-1">Billing Enabled</label>
        <small class="text-500">
          Off: this tenant is skipped entirely by the daily billing cron - no new invoices, no
          charges, no retries - while every other tenant's billing continues untouched. The
          emergency kill switch; use Charge Attempts Enabled below instead if you only want to
          stop automatic charges while still generating invoices.
        </small>
      </div>
      <p-inputSwitch [(ngModel)]="billingEnabled"></p-inputSwitch>
    </div>

    <div class="flex align-items-center justify-content-between gap-3">
      <div>
        <label class="block font-medium text-900 mb-1">Charge Attempts Enabled</label>
        <small class="text-500">
          Off: invoices still generate normally on schedule, but no automatic gateway charge is
          submitted - the transaction is left pending. For a tenant mid-migration off a legacy
          billing system that is still the one actually charging the customer this cycle. Inbound
          payment webhooks still reconcile normally either way.
        </small>
      </div>
      <p-inputSwitch [(ngModel)]="billingChargeAttemptsEnabled"></p-inputSwitch>
    </div>

    <div class="flex align-items-center justify-content-between gap-3">
      <div>
        <label class="block font-medium text-900 mb-1">Workflows Enabled</label>
        <small class="text-500">
          Off: the subscription status state machine is skipped entirely for this tenant - status
          changes are still recorded, but nothing downstream fires (no activation workflows,
          install notifications, etc). Added after a Gaiia-imported customer had a real activation
          workflow wrongly re-triggered by an import; use this to import/backfill data safely
          before flipping it back on.
        </small>
      </div>
      <p-inputSwitch [(ngModel)]="workflowsEnabled"></p-inputSwitch>
    </div>
  </div>

  <div *ngIf="!loading" class="flex justify-content-end mt-4">
    <p-button
      label="Save Safety Flags"
      icon="pi pi-check"
      styleClass="p-button-primary"
      [loading]="saving"
      (onClick)="save()"
    ></p-button>
  </div>
</div>
